import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  signatureAccuracyIcon,
  signatureAccuracyIconActive,
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class SignatureAccuracyButton extends Component {
  
  toggleSignatureAccuracy = (e) => {
    const {
      routeId, stopId, enableSignatureAccuracyAction, 
      disableSignatureAccuracyAction, signatureAccuracyIsEnabled,
      addSignatureAccuracyToMapAction, removeSignatureAccuracyFromMapAction
    } = this.props;
    e.stopPropagation();
    removeSignatureAccuracyFromMapAction(routeId, stopId);
    if (signatureAccuracyIsEnabled) {
      disableSignatureAccuracyAction(routeId, stopId);
    } else {
      enableSignatureAccuracyAction(routeId, stopId);
      addSignatureAccuracyToMapAction(routeId, stopId);
    }
  }

  componentDidMount = () => {
    const {
      routeId, stopId, signatureAccuracyIsEnabled,
      addSignatureAccuracyToMapAction
    } = this.props;
    if (signatureAccuracyIsEnabled) {
      addSignatureAccuracyToMapAction(routeId, stopId);
    }
  }

  render() {
    const { signatureAccuracyIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.zones.signatureAccuracy')}
      isActive={signatureAccuracyIsEnabled} 
      iconUrl={signatureAccuracyIcon}
      activeIconUrl={signatureAccuracyIconActive}
      onClick={this.toggleSignatureAccuracy}
      {...others}/>
    );
  }
}

SignatureAccuracyButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  signatureAccuracyIsEnabled: PropTypes.bool.isRequired,
  enableSignatureAccuracyAction: PropTypes.func.isRequired,
  disableSignatureAccuracyAction: PropTypes.func.isRequired,
  addSignatureAccuracyToMapAction: PropTypes.func.isRequired,
  removeSignatureAccuracyFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  signatureAccuracyIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'signatureAccuracyIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableSignatureAccuracyAction: bindActionCreators(actions.enableSignatureAccuracy, dispatch),
  disableSignatureAccuracyAction: bindActionCreators(actions.disableSignatureAccuracy, dispatch),
  addSignatureAccuracyToMapAction: bindActionCreators(actions.addSignatureAccuracyToMap, dispatch),
  removeSignatureAccuracyFromMapAction: bindActionCreators(actions.removeSignatureAccuracyFromMap, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignatureAccuracyButton);

